import React, { useState } from 'react';
import "../popupsteps/style/popupstyle.css";
interface StepProps {
    recordId: string; // The record ID passed to the component
    handleClose: () => void; // Function to close the popup
    onUpdate: (updatedRecord: any) => void; // Function to handle updates
    handleInputChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement>) => void; // Input change handler
    formData: {
        targetConversionRate?: string;
        targetCostPerConversion?: string;
        optimizationTimeframe?: string;
        minimumClicks?: string;
        setFactor?: string;
        maxOverrideBid?: string;
        minOverrideBid?: string;
    }; // The form data
}

const BidAutomationPopup: React.FC<StepProps> = ({
    recordId,
    handleClose,
    onUpdate,
    handleInputChange,
    formData,
}) => {
    const handleSave = () => {
        const updatedRecord = {
            recordId,
            ...formData,
        };
        onUpdate(updatedRecord);
        handleClose();
    };

    return (
        <div className="popup-container">


            <div className="popup-header">
                <h4 style={{ fontSize: '12px' }}>Campaign: Bid Automation</h4>
            </div>


            <div className='TextSize'>
                <p >Automatic optimization allows you to automatically blacklist subids and/or automatically set bids to subids by certain rules that you set.            </p>

                <p>Before activating this feature, please make sure that your conversions are tracked correctly via the Global Postback and that you know what you are doing!
                </p>
                <p>You can always reset everything by deleting all values under the "Blacklist Subids" and "Bid Override" because this feature simply automates the task that you can manually do by using these two features.
                </p>

            </div>



            <div className="popup-content">
                <p style={{ fontSize: '11px', width: '60%', color: '#990429', fontWeight: '500' }}>
                    Please use the following tool with caution and make sure you are tracking your campaign well and that you
                    know what you are doing. If needed, please consult our support team.
                </p>
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ fontSize: '12px', fontWeight: '500' }}>
                        <input type="radio" name="blacklistType" value="conversionRate" /> Enable Automatic Optimization:
                    </label>
                    <div style={{ marginLeft: '20px' }}>
                        <div>
                            <label style={{ fontSize: '12px' }}>
                                <input type="radio" name="blacklistType" value="conversionRate" /> 	Enable Automatic Optimization:
                            </label>
                            <p style={{ fontSize: '10px', marginLeft: '24px', marginTop: '-2px' }}>
                                Blacklist subids that fall below certain conversion rate or target cost per conversion:

                            </p>
                        </div>

                        <div style={{ marginLeft: '20px' }}>
                            {/* ----------------------------------------------------------------------------------------------- */}
                            <div>
                                <label style={{ fontSize: '12px' }}>
                                    <input type="radio" name="blacklistType" value="conversionRate" /> 		Target conversion rate:
                                </label>
                                <div style={{ display: 'flex' }}>

                                    <p style={{ width: '60%', fontSize: '10px', marginLeft: '24px', marginTop: '-2px' }}>
                                        For example, subid that generated 4 conversions from 2000 clicks (4/2000*100 = %0.2) with a Target conversion rate that was set to 0.5% will be blacklisted because %0.2 &lt; 0.5%
                                    </p>
                                    <label >

                                        <input
                                            type="text"
                                            name="targetCostPerConversion"
                                            value={formData.targetCostPerConversion || ''}
                                            onChange={handleInputChange}
                                            placeholder=" %"
                                            style={{

                                                marginTop: '-8px',
                                                padding: '6px 0px',
                                                width: '80px',
                                                fontSize: '12px',
                                                border: '1px solid lightgray',
                                                borderRadius: '5px',
                                            }}
                                        />
                                    </label>
                                </div>
                            </div>


                            <div>
                                <label style={{ fontSize: '12px' }}>
                                    <input type="radio" name="blacklistType" value="conversionRate" /> Target cost per conversion:

                                </label>
                                <div style={{ display: 'flex' }}>

                                    <p style={{ width: '60%', fontSize: '10px', marginLeft: '24px', marginTop: '-2px' }}>
                                        For example, subid that generated 5 conversions from 2000 clicks with a general campaign bid of $0.01 (total cost of 2000*0.01=$20 which means 20/5=$4 cost per conversion) with a target cost per conversion of $2 will be blacklisted because $4 &lt; $2
                                        <br></br>
                                        (you may want to use the subid automatic bidding instead of this option because it is better to set lower bid for such source instead of blocking it)                                </p>
                                    <label >

                                        <input
                                            type="text"
                                            name="targetCostPerConversion"
                                            value={formData.targetCostPerConversion || ''}
                                            onChange={handleInputChange}
                                            placeholder=" %"
                                            style={{

                                                marginTop: '-8px',
                                                padding: '6px 0px',
                                                width: '80px',
                                                fontSize: '12px',
                                                border: '1px solid lightgray',
                                                borderRadius: '5px',
                                            }}
                                        />
                                    </label>
                                </div>
                            </div>



                            <div style={{ marginLeft: '20px' }} className='Textlabel'>
                                <label>
                                    Optimization Timeframe:
                                    <select
                                        name="optimizationTimeframe"
                                        value={formData.optimizationTimeframe || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '5px',
                                            fontSize: '12px',
                                            border: '1px solid lightgray',
                                            marginBottom: '10px',
                                            width: '100px'
                                        }}
                                    >
                                        <option value="1 Week">1 Week</option>
                                        <option value="2 Week">2 Week</option>
                                        <option value="3 Month">3 Week</option>
                                        <option value="1 Month">1 Month</option>

                                    </select>
                                </label>
                                <br />
                                <label>
                                    Minimum Clicks:
                                    <input
                                        type="text"
                                        name="minimumClicks"
                                        value={formData.minimumClicks || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '5px',
                                            fontSize: '12px',
                                            border: '1px solid lightgray',
                                            marginBottom: '10px',
                                            width: '100px'
                                        }}
                                    />
                                </label>
                                <br />
                                
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className="popup-actions" style={{ marginTop: '20px' }}>
            <div>
                                <label style={{ fontSize: '12px' }}>
                                    <input type="radio" name="blacklistType" value="conversionRate" />  Enable Subid automatic bidding:

                                </label>
                                <div style={{ display: 'flex' }}>

                                    <p style={{ width: '60%', fontSize: '10px', marginLeft: '24px', marginTop: '-2px' }}>
                                    Sets bid per source automatically by revenue and factor. This bid will override the general campaign bid.
                                    For example, subid that generated $40 from 2000 clicks and with a factor of %80 will get bid of 40/2000*0.8 = $0.016. 80% factor means 20% profit while 50% factor means 50% profit, however, the lower the factor is - the lower your bid will be so less traffic will be delivered, so you will need to find the right path between profit and traffic.                             </p>
                                    
                                </div>
                            </div>



                            <div style={{ marginLeft: '20px' }} className='Textlabel'>
                                <label>
                                    Optimization Timeframe:
                                    <select
                                        name="optimizationTimeframe"
                                        value={formData.optimizationTimeframe || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '5px',
                                            fontSize: '12px',
                                            border: '1px solid lightgray',
                                            marginBottom: '10px',
                                            width: '100px'
                                        }}
                                    >
                                        <option value="1 Week">1 Week</option>
                                        <option value="2 Week">2 Week</option>
                                        <option value="3 Month">3 Week</option>
                                        <option value="1 Month">1 Month</option>

                                    </select>
                                </label>
                                <br />
                                <label>
                                    Minimum Clicks:
                                    <input
                                        type="text"
                                        name="minimumClicks"
                                        value={formData.minimumClicks || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '5px',
                                            fontSize: '12px',
                                            border: '1px solid lightgray',
                                            marginBottom: '10px',
                                            width: '100px'
                                        }}
                                    />
                                </label>
                                <br />
                                <label>
                                    Set Factor:
                                    <input
                                        type="text"
                                        name="setFactor"
                                        value={formData.setFactor || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '5px',
                                            fontSize: '12px',
                                            border: '1px solid lightgray',
                                            marginBottom: '10px',
                                            width: '100px'
                                        }}
                                    />
                                </label>
                                <br />
                                <label>
                                    Max Override Bid:
                                    <input
                                        type="text"
                                        name="maxOverrideBid"
                                        value={formData.maxOverrideBid || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '5px',
                                            fontSize: '12px',
                                            border: '1px solid lightgray',
                                            marginBottom: '10px',
                                            width: '100px'
                                        }}
                                    />
                                </label>
                                <br />
                                <label>
                                    Min Override Bid:
                                    <input
                                        type="text"
                                        name="minOverrideBid"
                                        value={formData.minOverrideBid || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '5px',
                                            fontSize: '12px',
                                            border: '1px solid lightgray',
                                            marginBottom: '10px',
                                            width: '100px'
                                        }}
                                    />
                                </label>
                            </div>
                
                
                <button
                    onClick={handleSave}
                    style={{
                        padding: '7px 40px',
                        backgroundColor: '#1173B7',
                        color: 'white',
                        fontSize: '12px',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                >
                    Update
                </button>
            </div>
        </div>
    );
};

export default BidAutomationPopup;
